import { OptionalNullableDisplayNameSchema } from '@sg/shared/src/valibot/schema/DisplayName.type'
import { InferOutput, object } from 'valibot'
import { PlayerColorSchema } from '../player/PlayerColor.type'
import { ArmyPaintIdSchema } from './ArmyPaintId.type'

export const ArmyPaintSchema = object({
  id: ArmyPaintIdSchema,
  dname: OptionalNullableDisplayNameSchema,
  color1: PlayerColorSchema,
  color2: PlayerColorSchema,
})

export type ArmyPaint = InferOutput<typeof ArmyPaintSchema>
